import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getBrands = async () => {
  const response = await axios.get(`${base_url}common/statelist/`);

  return response.data;
};
const getClusters = async () => {
  const response = await axios.get(`${base_url}common/clusterlist`);

  return response.data;
};

const createBrand = async (classes) => {
  console.log(classes);
  const response = await axios.post(`${base_url}common/createState`, classes, config);

  return response.data;
};
const createCluster = async (classes) => {
  console.log(classes);
  const response = await axios.post(`${base_url}common/createCluster`, classes, config);

  return response.data;
};
const updateBrand = async (brand) => {
  const response = await axios.put(
    `${base_url}sectors/${brand.id}`,
    { title: brand.brandData.title },
    config
  );

  return response.data;
};
const getBrand = async (id) => {
  const response = await axios.get(`${base_url}sectors/${id}`, config);

  return response.data;
};

const deleteBrand = async (id) => {
  const response = await axios.delete(`${base_url}sectors/${id}`, config);

  return response.data;
};

const clusterService = {
  getBrands,
  getClusters,
  createBrand,
  createCluster,
  getBrand,
  updateBrand,
  deleteBrand,
};

export default clusterService;
